/*
  <capra-units>: the Metric / Imperial toggle for every size table. Both units
  are already in the HTML; this only switches which one is shown, for every table
  on the site at once, and remembers the choice. The first paint is right
  because layout/theme.liquid sets data-units on <html> before anything renders.
*/
const KEY = 'capra:units';

class CapraUnits extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-unit]');
      if (button) CapraUnits.set(button.dataset.unit);
    });
    CapraUnits.sync();
  }

  static set(unit) {
    document.documentElement.dataset.units = unit;
    try {
      localStorage.setItem(KEY, unit);
    } catch {
      /* private mode: the choice lasts for this page only */
    }
    CapraUnits.sync();
  }

  static sync() {
    const unit = document.documentElement.dataset.units;
    for (const button of document.querySelectorAll('capra-units [data-unit]')) {
      button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
    }
  }
}

window.addEventListener('storage', (event) => {
  if (event.key === KEY && event.newValue) {
    document.documentElement.dataset.units = event.newValue;
    CapraUnits.sync();
  }
});

customElements.define('capra-units', CapraUnits);
